import React from "react";
import type { IconProps } from "./types";

/**
 * An italic icon component that displays a slanted text,
 * representing emphasis, style, or a different writing style.
 * @param props - The component props
 * @param props.className - Optional CSS class name to apply to the SVG element
 * @param props.width - The width of the icon in pixels
 * @param props.height - The height of the icon in pixels
 * @returns A React functional component that renders an italic SVG icon
 */
const ItalicIcon: React.FC<IconProps> = ({ className, width = 16, height = 16 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M4.71484 1.43018H11.2848M11.2848 14.5702H4.71484M7.99984 1.43018L7.99983 14.5702"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ItalicIcon;
